import { Root } from "react-dom/client";
import { AddBizReactLoader } from "../../../Js/React/loader";
import BizSpeedquiz from "./speedquiz";
import HighscoreMini from "./HighscoreMini";
import HighscoreCollection from "./HighscoreCollection";

let root: Root | undefined;

AddBizReactLoader(root, 'bizspeedquiz', (e) => {
	const params = (e.detail as { params: { quizId: number; fromOneQuiz: boolean } }).params;
	return <BizSpeedquiz quizId={params.quizId} fromOneQuiz={params.fromOneQuiz} />;
});

AddBizReactLoader(root, 'bizspeedquizhighscoremini', () => {
	return <HighscoreMini />;
});

AddBizReactLoader(root, 'bizspeedquizhighscorecollection', () => {
	return <HighscoreCollection />;
});